import { $Q } from "../utils/query-selector";
import { toggleDataActive } from "../utils/toggle-dataset"


/**
  * Rendering the zoom image of the product
  * 
  * @returns {Function} - Zoom image with snippet product-modal
  * 
  * @author Andres Briñez
  */

export const zoomImage = () => {
  const activeBtn = $Q('.zoom-button');
  
  toggleDataActive('.zoom-button','#product-modal',{ overlay: true })

  activeBtn.addEventListener('click', () =>{
    const image = $Q('.swiper-slide-active');
    updateImage(image);
  })
}

/**
 * Update the modal to the active image that should be displayed
 * 
 * @param { object } image node that stores the image to display
 */

function updateImage(image){
  const modal = $Q('.information-modal-wrapper');
  const container = $Q('.product-modal');

  container.classList.add('zoom-container');
  modal.classList.add('zoom-image');

  modal.innerHTML = image.innerHTML;

}